import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowRight } from 'lucide-react';

export function HeroSection() {
  return (
    <section className="relative min-h-[85vh] overflow-hidden bg-white">
      {/* Hero Image — full bleed, higher contrast/saturation matching reference */}
      <div className="absolute inset-0">
        <img
          src="https://customer-assets.emergentagent.com/job_aba09961-4794-4aa1-83b0-5d53d18a8e4b/artifacts/gqyawlln_latest.png"
          alt="Modern Office Space with Modular Workstations and Privacy Booths"
          className="w-full h-full object-cover object-[70%_center] sm:object-center"
          style={{ filter: 'contrast(1.12) saturate(1.18) brightness(1.02)' }}
          loading="eager"
          fetchPriority="high"
          decoding="async"
          width={1920}
          height={1080}
        />
        {/* Left-side gradient: strong white fade for text readability, transparent on right to show image */}
        <div className="absolute inset-0 hidden sm:block" style={{ background: 'linear-gradient(to right, white 0%, white 25%, rgba(255,255,255,0.85) 35%, rgba(255,255,255,0.45) 50%, rgba(255,255,255,0.1) 65%, transparent 75%)' }} />
        {/* Mobile: top-to-bottom gradient so image peeks from behind text */}
        <div className="absolute inset-0 sm:hidden" style={{ background: 'linear-gradient(to bottom, rgba(255,255,255,0.92) 0%, rgba(255,255,255,0.75) 50%, rgba(255,255,255,0.4) 75%, rgba(255,255,255,0.15) 100%)' }} />
      </div>

      <div className="relative z-10 container mx-auto px-4 sm:px-8">
        <div className="flex flex-col justify-center min-h-[85vh] pt-24 sm:pt-32 pb-16 sm:pb-20 max-w-2xl">
          
          {/* Badge */}
          <div className="flex flex-wrap items-center gap-2 sm:gap-3 mb-6 sm:mb-8">
            <div className="bg-[#1a1a1a] text-white px-3 sm:px-5 py-2 sm:py-2.5 text-xs sm:text-sm font-bold tracking-wider">
              FACTORY DIRECT = 30% SAVINGS
            </div>
            <span className="text-gray-600 text-xs sm:text-sm font-medium">No Middlemen. No Markups.</span>
          </div>

          {/* Hero Headlines */}
          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-black text-[#1a1a1a] mb-3 sm:mb-4 uppercase tracking-tight leading-[0.95]" >
            OFFICE FURNITURE<br />
            <span className="text-[#c5a059]">DIRECT FROM</span>
          </h1>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-black text-[#c5a059] italic mb-4 sm:mb-5" >
            OUR FACTORY
          </h2>

          {/* Kholo Jodo Lagalo Tagline — accent color pop */}
          <div className="mb-6 sm:mb-8">
            <p className="text-xl sm:text-2xl md:text-3xl font-black tracking-tight" >
              <span className="text-[#2E7D32]">Kholo</span>
              <span className="text-[#c5a059] mx-1">.</span>
              <span className="text-[#2E7D32]">Jodo</span>
              <span className="text-[#c5a059] mx-1">.</span>
              <span className="text-[#2E7D32]">Lagalo</span>
              <span className="text-[#c5a059]">.</span>
            </p>
          </div>

          {/* What We Offer */}
          <p className="text-[#1a1a1a] text-base sm:text-lg max-w-xl mb-1.5 font-medium">
            Workstations • Privacy Booths • Storage Solutions
          </p>
          <p className="text-gray-600 text-sm sm:text-base max-w-xl mb-8 sm:mb-10">
            From 1 desk to 500+ seats — Pan-India delivery in 7-14 days
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-wrap items-center gap-3 sm:gap-4">
            <Link to="/products">
              <Button className="bg-[#c5a059] hover:bg-[#b8934d] text-white rounded-none px-6 sm:px-8 py-4 sm:py-5 text-xs sm:text-sm tracking-[0.15em] font-bold transition-all" data-testid="hero-view-products">
                VIEW PRODUCTS & PRICES
                <ArrowRight className="w-4 h-4 ml-2" />
              </Button>
            </Link>
            <Link to="/contact">
              <Button variant="outline" className="border-2 border-[#1a1a1a] text-[#1a1a1a] hover:bg-[#1a1a1a] hover:text-white rounded-none px-5 sm:px-6 py-4 sm:py-5 text-xs sm:text-sm tracking-[0.15em] font-bold bg-transparent" data-testid="hero-get-quote">
                GET FREE QUOTE
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
